import { render, staticRenderFns } from "./CourseCardAboutInstructor.vue?vue&type=template&id=a5e79c0e&scoped=true&"
import script from "./CourseCardAboutInstructor.vue?vue&type=script&lang=js&"
export * from "./CourseCardAboutInstructor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e79c0e",
  null
  
)

export default component.exports